import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  FwButtonComponent,
  FwCheckboxComponent,
  FwDialogActionsComponent,
  FwDialogComponent,
  FwDialogContentComponent,
  FwDialogHeaderComponent,
  FwIconComponent,
} from '@flywheel-io/vision';

export const IGNORE_EXPIRATION_KEY = 'keysToIgnoreExpiration';
export interface ExpiredApiKey {
  label: string;
  key: string;
  isExpired: boolean;
  formattedDate: string;
}
export interface ExpiredApiKeysDialogData {
  userKeys?: ExpiredApiKey[];
  deviceKeys?: ExpiredApiKey[];
  deviceMTLSCertificates?: ExpiredApiKey[];
}

@Component({
  host: {
    class: 'mat-dialog-component',
    'test-id': 'expired-api-keys-dialog',
  },
  selector: 'expired-api-keys-dialog',
  templateUrl: './expired-api-keys-dialog.component.html',
  styleUrls: ['./expired-api-keys-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    FwButtonComponent,
    FwCheckboxComponent,
    FwDialogActionsComponent,
    FwDialogComponent,
    FwDialogContentComponent,
    FwDialogHeaderComponent,
    FwIconComponent,
  ],
})
export class ExpiredApiKeysDialogComponent implements OnInit {
  data = inject<ExpiredApiKeysDialogData>(DIALOG_DATA);
  private dialogRef = inject<DialogRef<ExpiredApiKeysDialogComponent>>(DialogRef);

  userKeys: ExpiredApiKey[];
  deviceKeys: ExpiredApiKey[];
  deviceMTLSCertificates: ExpiredApiKey[];
  doNotShow = false;

  ngOnInit(): void {
    this.userKeys = this.data?.userKeys || [];
    this.deviceKeys = this.data?.deviceKeys || [];
    this.deviceMTLSCertificates = this.data?.deviceMTLSCertificates || [];
  }

  updateIgnoredKeys(): void {
    const keysToIgnore = [
      ...this.userKeys.map((k) => k.key),
      ...this.deviceKeys.map((k) => k.key),
      ...this.deviceMTLSCertificates.map((k) => k.key),
    ];
    let ignoredKeys = [];
    try {
      const allIgnoredKeys = new Set([...JSON.parse(localStorage.getItem(IGNORE_EXPIRATION_KEY)), ...keysToIgnore]);
      ignoredKeys = [...allIgnoredKeys];
    } catch (error) {
      ignoredKeys = keysToIgnore;
    }
    localStorage.setItem(IGNORE_EXPIRATION_KEY, JSON.stringify(ignoredKeys));
  }

  close(): void {
    if (this.doNotShow) {
      this.updateIgnoredKeys();
    }
    this.dialogRef.close();
  }
}
